import { ProjectorFn } from "./projectorFn";
import { ReplacerFn } from "./replacerFn";

export const METHOD_METADATA_KEY = "$methodMetadata";
export interface MethodMetadata<TReturn = unknown>
{
    project?: ProjectorFn<TReturn>;
    replacer?: ReplacerFn<TReturn>;
}
